import { useState } from 'react';
import { useFadeIn } from '@/hooks/useFadeIn';

export default function Information() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // 各情報ブロックを個別にフェードイン
  const block0 = useFadeIn(0);
  const block1 = useFadeIn(100);
  const block2 = useFadeIn(200);
  const block3 = useFadeIn(300);
  const block4 = useFadeIn(400);
  const block5 = useFadeIn(500);

  const infoBlocks = [block0, block1, block2, block3, block4, block5];

  const fadeClass = (hook: ReturnType<typeof useFadeIn>) =>
    `transition-all duration-[800ms] ease-out ${hook.isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-6 scale-[0.97]'}`;

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const infoItems = [
    {
      icon: 'ri-ticket-line',
      title: 'チケット購入方法',
      description: '※ローソンチケット、アニメイトチケットにてチケット販売中。詳細は各公演ページをご確認下さい。'
    },
    {
      icon: 'ri-repeat-line',
      title: '転売・譲渡について',
      description: `チケットの転売・譲渡は固くお断りいたします。

イベント当日は入場時に以下の《顔写真付き身分証明書》によるご本人確認をさせて頂く場合がございます。

運転免許証／パスポート／在留カードまたは特別永住者証明書／障害者手帳／顔写真付きクレジットカード/マイナンバーカード／顔写真付き住民基本台帳カード(住基カード)／学生証(顔写真付き)／社員証(顔写真付き)

確認時、上記指定の顔写真付き身分証明書をお持ちでない場合、入場をお断りさせて頂きます。必ずご持参の上、予めご了承ください。`
    },
    {
      icon: 'ri-error-warning-line',
      title: 'ライブツアー注意事項',
      description: `※未就学児入場不可です。
※別途、プレイガイドでの手数料がかかります。
※公演が中止・延期となった場合以外での、お客様都合による払い戻しはしません。
※公演が中止・延期となった場合以外での、チケット購入者様のご判断にて来場をされない場合(新型コロナウイルス・インフルエンザなどの感染症・体調不良等含む)、公演が実施された場合は、お客様のご事情によるキャンセル・払戻しはしかねます。
※会場の都合等により開場／開演時間は変更となる場合がございます。
※チケットの営利目的の転売行為は禁止します。`
    },
    {
      icon: 'ri-video-line',
      title: '会場内でのご鑑賞にあたって',
      description: `・入場後、再入場はできません。
・座席によってはステージや演出の一部が見えにくい場合がございます。予めご了承ください。
・体を必要以上に大きく動かすような、周りのお客様のご迷惑になる行為はお控えください。またご自身の座席を離れる、通路へ駆け出すなどの行為は大変危険です。絶対におやめください。また、他のお客様のご迷惑となる過度な声援、公演の進行およびパフォーマンスの妨げとなる行為は禁止です。ご退場頂く場合がございます。
・会場内での録音・録画・撮影等は一切禁止させて頂いております。そのような行為が発見された場合、データ削除の上、退場もしくは公演を中止させて頂く場合もございますのでご了承ください。
・会場内へは、缶・ビン類、火薬などを含む危険物、アルコール飲料などの持ち込みは禁止とさせて頂きます。 また飲酒後、酒気帯びでのイベント参加は禁止です。
・会場内でのお食事はお控えください。お飲み物はペットボトル等、フタ付のものをご用意ください。
・会場内外におきましては、いかなる場合でも密集行為を禁止とさせて頂きます。
・演出・出演者の意向により、ペンライトやケミカルライト(サイリューム)等の光を発する物や、ネームボード等の応援グッズの持ち込みは一切ご遠慮くださいますようお願いします。
・応援グッズのお持ち込みが確認された場合、入り口にてお預かりすることになりますので、予めご了承ください。
・当日、入場時に手荷物検査を実施させて頂きます。カメラ、ビデオカメラ、MD、テープレコーダー、ICレコーダー等の録音録画機器、レーザーポインター、燃料類、大量のライターやマッチ等の可燃性が高いもの、刃物、ハンマー、ドライバー等、凶器として使用される恐れのあるもの、その他スタッフが危険であると判断した物品に関してのお持ち込みは固くお断りさせて頂きます。
・会場内のコインロッカーはご使用頂けますが、数に限りがございますので、お手荷物は各自で管理をお願いします。 キャリーバックのような大きなお荷物は駅内のコインロッカー等にあらかじめお預け頂きますよう、ご協力をお願いします。
・お荷物の放置は盗難の原因となりますので禁止です。万が一、荷物の盗難があった場合、ライブ主催者・会場・出演者側では一切責任を負いませんのでご注意ください。

上記に加え、自由席にご参加頂くお客様は、以下の事項を必ずご確認・ご承諾の上でご来場ください。
※当日は軽装、スニーカーなど動きやすい格好でお越しください。
※自由席となりますので、前の人に重なると見え難いことがあります。過度なアップスタイルやまとめ髪などの髪型や、帽子やフード等の着用は後方のお客様のご迷惑になる場合がありますので、ご遠慮ください。
※ステージ前へ駆け出す、前方に押し寄せる、柵を乗り越える等の行為は大変危険ですので、絶対におやめください。
※お荷物による場所取り、複数席の確保は禁止です。`
    },
    {
      icon: 'ri-flower-line',
      title: '祝花に関するご案内 NEW',
      description: `今回はスタンド花のみの受付とさせて頂きます。
楽屋花・花束等に関しては受け取りができませんのでご了承ください。
お送り頂きましたスタンド花につきましては、会場スペースの都合上、可能な範囲でロビーに飾らせて頂きます。
多数のスタンド花を頂きました場合、すべてを飾ることができない場合もございますので、あらかじめご了承ください。

●お客様がご自身でご手配される際は、以下の点にご注意ください。
下記に記載の規定が守られない物に関しては受取をお断りさせて頂く場合がございますので、必ずご確認ください。

◇大きさ
フラワースタンドについては、底辺(スタンド足部分)が40センチ×40センチ以下、高さが180センチ以下のものでお願いします。お花、飾り部分が上記のサイズから大きくはみ出しているものに関しては、飾ることができない場合もございます。ご了承ください。

◇到着・回収日時指定、送付先について
指定到着日時・回収可能時間をご確認のうえ、生花店様、宅配業者様にご指示ください。
また、必ず指定回収日時にお引き取りをして頂くよう、業者様ご依頼頂きますようお願いします。

▼東京(東京ドームKanadevia Hall)公演
指定到着日時：2026/4/13(月)10:00〜13:00
指定回収日時：2026/4/13(月)19:00〜21:00
［スタンド花 送付先］
〒112-0004 東京都文京区後楽1-3-61 ミーツポート1F 東京ドームKanadevia Hall「入野自由ライブ」スタンド花受付宛
お問合せ：チッタワークス 044-276-8841 / 平日12:00〜13:00・16:00〜18:00(土・日・祝祭日休み)

▼大阪公演
指定到着日時：2026/4/17(金)10:00〜13:00
指定回収日時：2026/4/17(金)18:00〜20:00
［スタンド花 送付先］
〒554-0031 大阪府大阪市此花区桜島1-1-61 Zepp Osaka Bayside「入野自由ライブ」スタンド花受付宛
お問合せ：グリーンズ 06-6882-1224 / 平日12:00〜18:00(土・日・祝祭日休み)

▼福岡公演
指定到着日時：2026/5/1(金)10:00〜13:00
指定回収日時：2026/5/1(金)18:00〜20:00
［スタンド花 送付先］
〒810-8639 福岡県福岡市中央区地行浜2-2-1 Zepp Fukuoka「入野自由ライブ」スタンド花受付宛
お問合せ：キョードー西日本 0570-09-2424 / 平日・土 11:00〜15:00(日・祝祭日休み)

▼羽田（Zepp Haneda(TOKYO)）公演　NEW
指定到着日時：5月27日(水) 10:00〜13:00
指定回収日時：5月27日(水) 19:00～21:00
［スタンド花 送付先］
〒144-0041　 東京都大田区羽田空港1-1-4　HANEDA INNVATION CITY ZONE H　Zepp Haneda(TOKYO)「入野自由ライブ」スタンド花受付宛
問い合わせ：チッタワークス/044-276-8841 / 平日12時〜13時,16時～18時(土・日・祝祭日休み)

スタンド花の掲出は、開演時間までとさせて頂きます。
上記の回収時間にお越し頂けない業者様に関しては、お受け取りしかますのでご注意ください。ご手配なさいます際に、必ずお客様より回収時間を業者様への事前連絡をお願いします。
スタンド引き取り時の間違いを防ぐため、スタンドには必ず店舗名が分かる目印を入れて頂くよう業者様へお伝えください。
上記以外のサイズに関してはお受け取りできない場合や、会場スペースの都合上飾れない場合がございますので、予めご了承ください。
指定時間外にお届けの場合、お受け取りしかねる場合もございますので、予めご了承ください。
スタンド花の会場内(会場敷地内の場外も含む)での設置場所についてはホール利用規定及び、消防法にのっとった形で主催側にて判断させて頂いた上、順不同で設置させて頂きます。設置場所や順番の指定のご希望には応じられませんので、予めご了承ください。
渋滞などの配達のトラブルなどで、開場時間に遅れる場合もございますので、そのような場合の責任は主催者側では負いかねますので、予めご了承ください。`
    },
    {
      icon: 'ri-gift-line',
      title: 'プレゼントに関するご案内',
      description: `出演者へのお手紙は、会場ロビーに設置しますお手紙BOXへお入れください。
お手紙以外のプレゼントに関しましては一切お預かりが出来ませんので、あらかじめご了承ください。お手紙BOXでは一般郵便物の規格サイズ封筒に同封された形のもののみ受け取り可能になります。一般郵便封筒以外のものは、プレゼントと見なしお断りさせて頂きます。
例)メッセージブック、ノート、CD、USB、小さな宅配ボックス形式等のお手紙はお預かり不可

お手紙以外のプレゼントはご遠慮頂いております。また、封筒内にお手紙以外の物品が同封されていた場合も、お受け取りできかねますのでご了承ください。`
    }
  ];

  return (
    <section 
      id="information" 
      className="py-20 px-4 font-['Noto_Sans_JP']"
    >
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#fcb122] px-6 md:px-12 py-3 md:py-4 shadow-[0_0_40px_#fcb122]">
            <h2 className="text-2xl md:text-5xl text-[#0a0a0a] font-bold font-press-start">INFORMATION</h2>
          </div>
        </div>

        <div className="space-y-4">
          {infoItems.map((item, index) => (
            <div
              key={index}
              ref={infoBlocks[index].ref}
              className={`bg-gradient-to-br from-[#1a1a3e] to-[#2a2a4e] border-4 border-[#44c4ff] overflow-hidden hover:border-[#1ef99d] transition-all duration-300 hover:shadow-[0_0_40px_#44c4ff] ${fadeClass(infoBlocks[index])}`}
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-6 md:p-8 text-left cursor-pointer hover:bg-white/5 transition-colors"
              >
                <div className="flex items-center gap-4 flex-1 min-w-0">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#44c4ff] border-2 border-[#44c4ff] flex-shrink-0 shadow-[0_0_15px_#44c4ff]">
                    <i className={`${item.icon} text-2xl text-black`}></i>
                  </div>
                  <h3 className="text-base md:text-lg text-[#44c4ff] font-bold font-['Noto_Sans_JP'] break-words min-w-0">
                    {item.title.replace(' NEW', '')}
                  </h3>
                </div>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <span className={`text-[#44c4ff] text-2xl transition-transform duration-300 font-dotgothic ${openIndex === index ? 'rotate-180' : ''}`}>
                    ▼
                  </span>
                </div>
              </button>
              
              <div
                className={`transition-all duration-300 ${
                  openIndex === index ? 'max-h-[10000px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-8 pb-4 md:pb-8 pt-0">
                  <div className="pl-4 md:pl-16 border-l-4 border-[#1ef99d] ml-2 md:ml-6">
                    <p className="text-xs md:text-sm text-white/90 leading-relaxed whitespace-pre-line font-['Noto_Sans_JP'] break-words">
                      {item.description.split(/(NEW)/g).map((part, i) =>
                        part === 'NEW'
                          ? <strong key={i} className="text-[#fc457e] font-bold">{part}</strong>
                          : part
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}